import * as R from 'ramda'
import {Session} from '../../Data/Session'
import {
    OrderExportOverviewState,
    OrderExportRow
} from './OrderExportOverviewState'
import {OrderExportOverviewAction} from './OrderExportOverviewActions'
import {
    OrderExportOverviewDownloadRequestIdentifier,
    OrderExportOverviewFeedback
} from './OrderExportOverviewFeedback'
import * as OrderExportResource from '../../Request/OrderExportResource'
import {Result} from '../../Data/Result'
import {HttpError} from '../../Data/Http'
import {update} from '../../Data/ObjectHelper'
import {OrderExport, orderExportDecoder} from '../../Entities/OrderExport'
import {array, Decoder} from 'json-bouncer'
import * as Downloadable from '../../Data/Downloadable'
import {FeedbackLoop} from '../../Data/FeedbackLoop'
import {HttpRequest} from '../../Data/HttpRequest'

type OrderExportOverviewLoop =
    FeedbackLoop<OrderExportOverviewState, OrderExportOverviewFeedback>

export function activate(session: Session): HttpRequest {
    return OrderExportResource.listForCis2User(
        session.manufacturer.id,
        session.cis2User.id,
    )
}

export function initialDecoder(): Decoder<OrderExport[]> {
    return array(orderExportDecoder())
}

export function init(orderExportRows: OrderExport[]): OrderExportOverviewState {
    return {
        orderExportRows:
            R.map(
                (orderExport): OrderExportRow => ({
                    orderExport,
                    download: {type: 'Default'}
                }),
                orderExportRows,
            )
    }
}

export function reduce(
    state: OrderExportOverviewState,
    action: OrderExportOverviewAction,
): OrderExportOverviewLoop {
    switch (action.type) {
        case 'MenuButtonClicked':
            return {state, feedback: [{type: 'OpenDrawer'}]}
        case 'DownloadOrderExport': {
            const orderExportRow =
                R.find(
                    row => row.orderExport.id === action.id,
                    state.orderExportRows,
                )
            if (typeof orderExportRow !== 'undefined' && orderExportRow.download.type !== 'Loading') {
                return {
                    state:
                        updateOrderExportRow(
                            row => update({download: {type: 'Loading'}}, row),
                            action.id,
                            state,
                        ),
                    feedback: [{
                        type: 'SendDownloadRequest',
                        identifier: {
                            type: 'OrderExportDownload',
                            id: action.id,
                        },
                        httpRequest: OrderExportResource.download(action.id),
                        filename: `${action.id}.zip`,
                    }],
                }
            } else {
                return {state, feedback: []}
            }
        }
        case 'OrderExportDownloadResponse': {
            return {
                state: updateOrderExportRow(
                    orderExportRow =>
                        update(
                            {download: Downloadable.fromResult(action.result)},
                            orderExportRow,
                        ),
                    action.id,
                    state,
                ),
                feedback: [],
            }
        }
    }
}

function updateOrderExportRow(
    fn: (row: OrderExportRow) => OrderExportRow,
    id: number,
    state: OrderExportOverviewState
): OrderExportOverviewState {
    return update(
        {
            orderExportRows:
                R.map(
                    orderExportRow =>
                        orderExportRow.orderExport.id === id
                            ? fn(orderExportRow)
                            : orderExportRow,
                    state.orderExportRows,
                ),
        },
        state,
    )
}

export function httpDownloadResponseAction(
    identifier: OrderExportOverviewDownloadRequestIdentifier,
    result: Result<HttpError, null>,
): OrderExportOverviewAction {
    switch (identifier.type) {
        case 'OrderExportDownload':
            return {
                type: 'OrderExportDownloadResponse',
                id: identifier.id,
                result,
            }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderExportOverview/OrderExportOverviewReducer.ts